module.exports = __webpack_public_path__ + "img/video_icon.cf8ab6a2.svg";